import Cookies from 'js-cookie'

export default defineNuxtRouteMiddleware((to) => {
  const token = useCookie('lk_token')
  if (!token.value) {
    Cookies.set('last_visit', to.fullPath)
    return navigateTo('/logout')
  }
})
